import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  CircularProgress,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { format } from 'date-fns';
import { fetchTermsChangelog } from 'lib/Api/TermsGenerator';
import { TermsChangelogItem } from 'lib/Model/TermsGenerator';

interface P {
  open: boolean;
  onClose: () => void;
  termsId: number;
  title?: string;
}

const useS = makeStyles((t: Theme) => ({
  rail: {
    borderLeft: `2px solid ${t.palette.divider}`,
    paddingLeft: t.spacing(2),
  },
  row: {
    paddingBottom: t.spacing(2),
  },
  head: {
    fontWeight: 600,
  },
  meta: {
    color: t.palette.text.secondary,
  },
  cont: {
    maxHeight: '60vh',
    overflowY: 'auto',
  },
}));

export const TermsChangelog: React.FC<P> = ({
  open,
  onClose,
  termsId,
  title,
}) => {
  const s = useS();
  const [a, setA] = useState<TermsChangelogItem[]>([]);
  const [b, setB] = useState(false);
  const [m, setM] = useState<string | null>(null);

  useEffect(() => {
    if (!open || !termsId) return;
    setB(true);
    setM(null);
    fetchTermsChangelog(termsId)
      .then((r) => setA(r || []))
      .catch(() => setM('Failed to load history.'))
      .finally(() => setB(false));
  }, [open, termsId]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      scroll="paper"
    >
      <DialogTitle>{title || 'Change History'}</DialogTitle>
      <DialogContent dividers className={s.cont}>
        {b ? (
          <Box display="flex" justifyContent="center" py={2}>
            <CircularProgress />
          </Box>
        ) : m ? (
          <Alert severity="error">{m}</Alert>
        ) : a.length === 0 ? (
          <Typography variant="body2" color="textSecondary">
            No history found.
          </Typography>
        ) : (
          <Box className={s.rail}>
            {a.map((x, i) => (
              <Box key={i} className={s.row}>
                <Typography variant="subtitle2" className={s.head}>
                  {x.event_type}
                </Typography>
                <Typography variant="caption" className={s.meta}>
                  {x.event_date
                    ? format(new Date(x.event_date), 'dd/MM/yyyy HH:mm')
                    : ''}
                </Typography>
                {x.update_details && (
                  <Typography variant="body2">{x.update_details}</Typography>
                )}
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
